/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Svc_Full_Art_State_3Inputs */

const en_services_svc_full_art_state_3 = /** @type {(inputs: Services_Svc_Full_Art_State_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Handled`)
};

const lv_services_svc_full_art_state_3 = /** @type {(inputs: Services_Svc_Full_Art_State_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apstrādāts`)
};

/**
* | output |
* | --- |
* | "Handled" |
*
* @param {Services_Svc_Full_Art_State_3Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_svc_full_art_state_3 = /** @type {((inputs?: Services_Svc_Full_Art_State_3Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Svc_Full_Art_State_3Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_svc_full_art_state_3(inputs)
	return en_services_svc_full_art_state_3(inputs)
});